export { MenuAlt3 as default } from './MenuAlt3';
